module.exports = __webpack_public_path__ + "static/community-slideshow-03-ceb44e78ec0dc22ae8ffb858750a6dbd.jpg";